import { Card, DataTable } from '@shopify/polaris';
import { formatToCurrency } from '../functions';
import { CardHeading } from './CardHeading';

// priceField: 'VP' (selling price) for sales documents, 'AP' (purchase price) for purchase orders
export function LinesTotalTable({ summary, lines, creditnotes, priceField = 'VP' }) {
  const lineValue = (line) => (line.aantal || 0) * (line[priceField] || 0);
  const lineTax = (line) => lineValue(line) * ((line.BTW || 0) / 100);

  const totalExclTax = lines.reduce((prev, line) => prev + lineValue(line), 0);
  const totalTax = lines.reduce((prev, line) => prev + lineTax(line), 0);
  const totalSaleValue = totalExclTax + totalTax;

  let rows = [
    ['Value excl tax', formatToCurrency(totalExclTax)],
    ['Taxes value', '+' + formatToCurrency(totalTax)],
    [`Total ${summary} value incl tax`, <b>{formatToCurrency(totalSaleValue)}</b>]
  ];

  if (creditnotes) {
    let totalCreditNotes = creditnotes
      .map((c) => {
        return c.BedragTotaal;
      })
      .reduce((p, c) => p + c, 0);
    totalCreditNotes = Math.round(totalCreditNotes * 100) / 100;
    let totalAfterCreditNote = totalSaleValue - totalCreditNotes;
    rows.push(['Credited value', '-' + formatToCurrency(totalCreditNotes)], [<b>Total value</b>, +totalAfterCreditNote === 0 ? '€ 0,00' : formatToCurrency(totalAfterCreditNote)]);
  }

  return <DataTable stickyHeader={true} increasedTableDensity={true} verticalAlign="middle" columnContentTypes={['text', 'numeric']} headings={[]} rows={rows} />;
}

export default function LinesTotalCard(props) {
  return (
    <Card>
      <CardHeading title="Summary" />
      <LinesTotalTable {...props} />
    </Card>
  );
}
